import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import {
  FaUser,
  FaSignOutAlt,
  FaChartBar,
  FaFutbol,
  FaInfoCircle,
} from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { logout as logoutAction } from '../slices/authSlice';
import {
  useGetUserProfileQuery,
  useLogoutMutation,
} from '../slices/usersApiSlices';
import { apiSlice } from '../slices/apiSlice';
import brandLogo from '../assets/logo.png';
import './Header.css';

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { userInfo } = useSelector((state) => state.auth);
  const [logout, { isLoading, isError }] = useLogoutMutation();
  const { data: profile } = useGetUserProfileQuery(undefined, {
    skip: !userInfo,
    refetchOnMountOrArgChange: true,
  });
  const signedInWithGoogle =
    userInfo?.signedInWithGoogle === true ||
    profile?.authProvider === 'google';
  const canUpdatePassword = !signedInWithGoogle;
  const normalizedPath = (() => {
    const p = (location.pathname || "/").replace(/\/+$/, "") || "/";
    if (p === "/") return "/SquadDataScreen";
    return p;
  })();
  const isAnalysisRoute = [
    '/ShotAnalysisScreen',
    '/PlayerAnalysisScreen',
    '/SeasonAnalysisScreen',
  ].includes(normalizedPath);
  const isManageDataRoute = [
    '/ShotDataScreen',
    '/SquadDataScreen',
  ].includes(normalizedPath);

  const logoutHandler = async () => {
    try {
      await logout().unwrap();
      dispatch(logoutAction());
      dispatch(apiSlice.util.resetApiState());
      navigate('/LoginScreen');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  /*
  useEffect(() => {
    if (!userInfo) {
      navigate('/LoginScreen');
    }
  }, [userInfo, navigate]);

  */

  return (
    <header className="app-header">
      <Navbar bg="dark" variant="dark" expand="md" collapseOnSelect className="app-navbar">
        <Container>
          <Navbar.Brand as={Link} to="/" className="app-brand d-md-none">
            <span className="app-brand-wrap">
              <img src={brandLogo} alt="ShotArc logo" className="app-brand-logo" />
              <span>ShotArc</span>
            </span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <div className="app-nav-layout w-100">
              <Nav className="app-nav-left">
                {userInfo && (
                  <>
                    <Nav.Link
                      as={Link}
                      to="/ShotAnalysisScreen"
                      className={`header-link ${isAnalysisRoute ? 'active' : ''}`}
                    >
                      <FaChartBar className="me-1" />
                      Analysis
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to="/ShotDataScreen"
                      className={`header-link ${isManageDataRoute ? 'active' : ''}`}
                    >
                      <FaFutbol className="me-1" />
                      Data Management
                    </Nav.Link>
                  </>
                )}
              </Nav>

              <div className="app-nav-center d-none d-md-flex">
                <span className="app-brand app-brand-wrap">
                  <img src={brandLogo} alt="ShotArc logo" className="app-brand-logo" />
                  <span>ShotArc</span>
                </span>
              </div>

              <Nav className="app-nav-right">
                {userInfo ? (
                  <NavDropdown title={userInfo.name} id="username" align="end">
                    <NavDropdown.Item
                      as={Link}
                      to="/InformationScreen"
                    >
                      <FaInfoCircle className="me-2" />
                      Information
                    </NavDropdown.Item>
                    {canUpdatePassword && (
                      <NavDropdown.Item
                        onClick={()=>{navigate("/UpdatePassword")}}
                      >
                        Update Password
                      </NavDropdown.Item>
                    )}
                    <NavDropdown.Divider />
                    <NavDropdown.Item
                      onClick={logoutHandler}
                      disabled={isLoading}
                    >
                      <FaSignOutAlt className="me-2" />
                      {isLoading ? 'Logging out...' : 'Logout'}
                    </NavDropdown.Item>
                    {isError && (
                      <div className="px-3 text-danger small">
                        Logout failed
                      </div>
                    )}
                  </NavDropdown>
                ) : (
                  <Nav.Link as={Link} to="/LoginScreen">
                    <FaUser className="me-1" />
                    Login
                  </Nav.Link>
                )}
              </Nav>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
